import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/tubelight-navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/cta-action-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SDPSIHero"] */ "/vercel/path0/src/components/ui/sdpsi-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsSection"] */ "/vercel/path0/src/components/ui/stats-section.tsx");
